
import { KeycloakService } from "keycloak-angular";
import { environment } from "src/environments/environment";

export function initializeKeycloak(keycloak: KeycloakService) {    
    // If maintenanceMode is enabled, skip Keycloak initialization to avoid redirect to login
    if ((<any>environment).maintenanceMode) {
        console.log('Keycloak init skipped due to maintenanceMode');
        return () => Promise.resolve();
    }

    return () =>
      keycloak.init({
        config: environment.keycloak,
        initOptions: {
          onLoad: 'login-required',
          checkLoginIframe: false //https://szoradi-balazs.medium.com/keycloak-login-infinite-loop-9005bcd9a915
        },
        enableBearerInterceptor: true,
        bearerPrefix: 'Bearer',
        bearerExcludedUrls: [
            '/assets',
            '/clients/public']
      });

}
